import RouterBase from '../../../../components/navigation/RouterBase'
import { URLAPP } from '../../../../config'
import ProfileEnviromentForm from './ProfileEnviromentForm'

export default function SarenvProfiles() {
    return (
        <RouterBase
            items={[
                {
                    component: <ProfileEnviromentForm businessLayer='core' />,
                    fullPath: URLAPP.sarenvProfileIndependiente,
                    nestedRouter: true
                },
                {
                    component: <ProfileEnviromentForm
                        businessLayer='core'
                        requestNss
                        requestImssName
                    />,
                    fullPath: URLAPP.sarenvProfileImssPuro,
                    nestedRouter: true
                },
                {
                    component: <ProfileEnviromentForm
                        businessLayer='core'
                        requestNss
                        requestAfore
                        requestImssName
                    />,
                    fullPath: URLAPP.sarenvProfileAsignado,
                    nestedRouter: true
                },
                {
                    component: <ProfileEnviromentForm
                        businessLayer='core'
                        requestNss
                        requestAfore
                        requestImssName
                    />,
                    fullPath: URLAPP.sarenvProfileImssRegistrado,
                    nestedRouter: true
                },
                {
                    component: <ProfileEnviromentForm
                        businessLayer='core'
                        requestNss
                        requestAfore
                        requestImssName
                    />,
                    fullPath: URLAPP.sarenvProfileMixto,
                    nestedRouter: true
                },
                {
                    component: <ProfileEnviromentForm
                        businessLayer='core'
                        requestAfore
                    />,
                    fullPath: URLAPP.sarenvProfileIsssteRegistrado,
                    nestedRouter: true
                },
                {
                    component: <ProfileEnviromentForm
                        businessLayer='app'
                        requestAfore
                        requestNss
                        requestSelfie
                        requestIdDocument
                        requestContactInfo
                        requestAdditionalDocument={['11', '13']}
                        requestImssName
                    />,
                    fullPath: URLAPP.sarenvProfileAvanzado,
                    nestedRouter: true
                },
                {
                    component: <ProfileEnviromentForm businessLayer='app' requestAfore />,
                    fullPath: URLAPP.sarenvChangeAfore,
                    nestedRouter: true
                }
            ]}
        />
    )
}
